import { connect } from "react-redux";

import { UsersIndex as Presenter, UsersIndexStateProps } from "./presenter";
import { GlobalState } from "@app/models/state";
import {
    getUsersMap,
    getOrganisationsMap,
    getRolesMap,
    getCurrentUserId,
    canCreateUser,
    canUpdateUser,
    canDeleteUser,
} from "@auth/selectors";
import { getLocale } from "@localisation/selectors";
import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { compose } from "recompose";

// Map the users state to the component.
function mapStateToProps(state: GlobalState) {
    return {
        users: getUsersMap(state),
        organisations: getOrganisationsMap(state),
        roles: getRolesMap(state),
        usersLastLoaded: state.auth.requests.usersIndexLastSuccess,
        userId: getCurrentUserId(state),
        canCreateUser: canCreateUser(state),
        canUpdateUser: canUpdateUser(state),
        canDeleteUser: canDeleteUser(state),
        locale: getLocale(state),
    } as UsersIndexStateProps;
}

type InnerProps = UsersIndexStateProps;
// type OuterProps = UsersIndexOwnProps;

const UsersIndex = compose<InnerProps, {}>(
    setTitleOnPage(messages.pageUsersTitle),
    connect(mapStateToProps, null),
)(Presenter);

export { UsersIndex };
